<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<app-no-data *ngIf="data.length <= 0 && !skelition"></app-no-data>
<div class="bg-img-v4 pb-5">
  <div
    [hidden]="skelition"
    *ngIf="data.length > 0"
    class="container mb-4 max-width-tabb"
  >
    <app-table
      [unit]="'ROLE_MANAGEMENT'"
      [data]="data"
      (actionCall)="actionCall($event)"
    ></app-table>
  </div>

  <!-- <hr class="hr"> -->
  <div class="container-fluid max-width-tabb">
    <h2 class="text-center color-ms-purple my-5">
      <i
        style="font-size: 2rem; font-weight: 600"
        class="pi pi-fw pi-plus-circle color-ms-purple mx-2"
      ></i
      >{{ "Create a new role" | translator }}
    </h2>
    <div
      [hidden]="skelition"
      *ngIf="
        questions.length > 0 &&
        permissionService.hasPermission('ROLE_MANAGEMENT', 'c')
      "
      class="container-fluid max-width-tabb p-0"
    >
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
      <app-dynamic-form
        [questions]="questions"
        (sendData)="receiveData($event)"
      ></app-dynamic-form>
    </div>
  </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="3" class="mb-2"></app-skelitions>
<!-- Update Data Modal -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Header"
  [(visible)]="updateModal"
  [style]="{ margin: '0rem 1rem', 'max-width': '800px' }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "The role update" | translator }}</span>
  </ng-template>
  <app-dynamic-form
    *ngIf="updateModal"
    [questions]="updateQuestions"
    (sendData)="UpdateData($event)"
  ></app-dynamic-form>
</p-dialog>
<!-- Confirm Modal -->
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<app-footer></app-footer>
